import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { BaseIcon } from '../../../components/base-icon.mjs';

const SvgTheatre = forwardRef((props, ref) => /* @__PURE__ */ jsxs(BaseIcon, { fill: "currentColor", ref, ...props, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      d: "m7.5 6.495-.007.002c-1.37.416-2.572 1.225-3.405 1.893a14 14 0 0 0-1.284 1.165l-.077.081-.022.024-.007.007-.002.003-.001.002a1 1 0 0 0-.216.961l1.89 6.22c.281.925.907 1.632 1.595 2.158.69.528 1.497.917 2.254 1.198.76.284 1.508.471 2.103.58.297.054.568.09.793.107q.17.014.329.012c.081-.002.243-.008.411-.06.168-.05.306-.135.374-.18a4 4 0 0 0 .267-.191c.177-.14.382-.32.6-.531l-.23-.115a14 14 0 0 1-2.068-1.307c-.49-.373-1.01-.824-1.49-1.35a1 1 0 0 1-1.707-1.04l.06-.103c.108-.19.237-.417.407-.65A5.4 5.4 0 0 1 7.5 13V6.495m-1.778 4.551a1 1 0 0 0 .581 1.914l.01-.003a1 1 0 1 0-.581-1.914z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      d: "M15 4c-1.431 0-2.817.425-3.809.822a14 14 0 0 0-1.567.741l-.097.055-.028.017-.009.005-.003.001-.001.002A1 1 0 0 0 9 6.5V13c0 .967.393 1.826.899 2.53s1.165 1.312 1.807 1.8c.646.493 1.307.89 1.845 1.166.268.139.517.252.728.334.104.04.21.078.31.107.079.022.236.063.411.063s.332-.041.41-.063q.153-.044.311-.107c.21-.082.46-.195.728-.334a12.7 12.7 0 0 0 1.845-1.165c.642-.49 1.301-1.097 1.807-1.801S21 13.967 21 13V6.5c0-.351-.185-.677-.486-.858h-.001l-.003-.002-.009-.005-.028-.017-.097-.055q-.125-.07-.348-.187a14 14 0 0 0-1.22-.554C17.819 4.425 16.433 4 15 4m5 2.5.514-.858s0 0-.514.858M13 7a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2zm4 0a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2zm-4.707 4.293a1 1 0 0 0 0 1.414l.084.085c.477.483 1.243 1.257 2.623 1.257s2.146-.774 2.623-1.257l.084-.085a1 1 0 0 0-1.414-1.414c-.53.53-.757.756-1.293.756s-.764-.227-1.293-.756a1 1 0 0 0-1.414 0",
      clipRule: "evenodd"
    }
  )
] }));

export { SvgTheatre as default };
//# sourceMappingURL=theatre.mjs.map
